import React from 'react';
import MyConnect from './MyConnect';

export default function Navigation() {
  return (
    <header className="flex container">
      <div className="main-logo">
        Santosh Balchandran
      </div>
       <MyConnect />
    </header>
  );
}
